module.exports = __webpack_public_path__ + "static/media/values.d4755cc9.jpg";